import angular from 'angular';
import {
  authorizationService, loaderService, orgDataService, userService,
} from 'app/services';
import { alerts } from 'app/components/global';
import LoginController from './login.controller';
import loginDirective from './login.directive';
import 'app/adalProviders/adal.angular';


export const routeConfig = {
  template: require('./login.html'),
  controller: 'LoginController',
  controllerAs: 'loginVM',
};

export default angular.module('app.components.membership.login', [
  'ngMessages',
  alerts,
  authorizationService,
  userService,
  loaderService,
  orgDataService,
  'AdalAngular',
])
  .directive('login', loginDirective)
  .controller('LoginController', LoginController)
  .name;

console.log('app.components.membership.login created');
